import * as React from "react";
import type { SVGProps } from "react";
const SvgCsv = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24" {...props}
  >
    <g
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    >
      <path
        d="M5.5 3.5h13a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2v-13a2 2 0 0 1 2-2"
        clipRule="evenodd"
      />
      <path d="M12 9.045a.125.125 0 1 0 .002.25.125.125 0 0 0-.002-.25M12 6.205a.125.125 0 1 0 .126.125.127.127 0 0 0-.126-.125M12 11.875a.125.125 0 1 0 .002.25.125.125 0 0 0-.002-.25M12 14.705a.125.125 0 1 0 .002.25.125.125 0 0 0-.002-.25M12 17.545a.125.125 0 1 0 .002.25.125.125 0 0 0-.002-.25M14.955 12a.125.125 0 1 0-.25.002.125.125 0 0 0 .25-.002M17.795 12a.125.125 0 1 0-.25.002.125.125 0 0 0 .25-.002M9.295 12a.125.125 0 1 0-.25.002.125.125 0 0 0 .25-.002M6.455 12a.125.125 0 1 0-.125.126.127.127 0 0 0 .125-.126" />
    </g>
  </svg>
);
export default SvgCsv;
